import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import ServerSideDataSource from './ServerSideDataSource';
import { updateCapitalMarket } from 'utils/apiRequests';
import { isEqual } from 'lodash';

class TableView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			gridApi: null,
		};
		// this.props.parentGridRef = React.createRef();
	}

	gridOptions = () => {
		const { data } = this.props;

		return {
			modules: AllModules,
			columnDefs: data.columnDefs,
			cacheBlockSize: 200,
			maxBlocksInCache: 6,
			enableColResize: true,
			enableSorting: false,
			enableFilter: true,
			rowHeight: 35,
			rowModelType: 'serverSide',
			maxConcurrentDatasourceRequests: 1,
			// multiSortKey: 'ctrl',
			enableRangeSelection: true,
			suppressCutToClipboard: true,
			getRowStyle: params => {
				if (params.node.rowIndex % 2 === 0) {
					return { backgroundColor: '#f9f9f9' }; // Light grey
				}
				return { backgroundColor: 'white' };
			},
		};
	};

	defaultColDefs = {
		flex: 1,
		minWidth: 100,
		resizable: true,
		editable: false,
	};

	componentDidUpdate(prevProps) {
		const {
			data,
			selectedDate,
			currentBreakDownFilter,
			currentFilterValuesSelected,
			dateRangeData,
			isDPOMultiplefilterData,
			dayDiff,
		} = this.props;
		if (!isEqual(this.props, prevProps)) {
			const gridOptionsnew = {
				data,
				suppressRowClickSelection: true,
				...this.gridOptions(),
				selectedDate,
				currentBreakDownFilter,
				currentFilterValuesSelected,
				isDPOMultiplefilterData,
				dateRangeData,
				dayDiff: dayDiff,
			};
			const datasource = ServerSideDataSource(
				gridOptionsnew,
				this.props.parentGridRef.current.columnApi,
				this.props.parentGridRef.current.api
			);
			this.props.parentGridRef.current.api.setServerSideDatasource(datasource);
		}
	}

	onGridReady = params => {
		this.gridColumnApi = params.columnApi;
		this.setState({ gridApi: params.api });
		const {
			data,
			selectedDate,
			currentBreakDownFilter,
			currentFilterValuesSelected,
			dateRangeData,
			dayDiff,
		} = this.props;
		const gridOptionsnew = {
			data,
			suppressRowClickSelection: true,
			...this.gridOptions(),
			selectedDate,
			dateRangeData,
			currentBreakDownFilter,
			currentFilterValuesSelected,
			dayDiff: dayDiff,
		};
		const datasource = ServerSideDataSource(
			gridOptionsnew,
			params.columnApi,
			params.api
		);
		// this.props.parentGridRef=this.props.parentGridRef;

		params.api.setServerSideDatasource(datasource);
		this.changeColumnWidth(params.columnApi);
	};

	changeColumnWidth = gridColumnApi => {
		gridColumnApi.setColumnWidth('ag-Grid-AutoColumn', 220);
	};

	handleCellValueChange = async event => {
		const { gridApi } = this.state;
		const selectedRowNodes = gridApi.getSelectedNodes();
		if (
			event.oldValue &&
			event.newValue &&
			event.oldValue.toString() === event.newValue.toString() &&
			selectedRowNodes.length === 1
		) {
			return;
		}
		const payload = {};

		payload.hARMONIZED_VENDOR_NAME = event.data.hARMONIZED_VENDOR_NAME;
		payload.extend_Term =
			event.data.select === 'NO' ||
			(event.data.pcard_Term && event.colDef.colId === 'pcard_Term')
				? null
				: event.data.extend_Term;
		payload.pcard_Term =
			event.data.select === 'NO' ||
			(event.data.extend_Term && event.colDef.colId === 'extend_Term')
				? null
				: event.data.pcard_Term;
		payload.select = event.data.select;

		if (
			(event.data.pcard_Term && event.colDef.colId === 'pcard_Term') ||
			(event.data.extend_Term && event.colDef.colId === 'extend_Term')
		) {
			payload.harmonization_Opportunity_Term = null;
			payload.harmonization_Opportunity_Term_Reduction = null;
			event.data.harmonization_Opportunity_Term = null;
			event.data.harmonization_Opportunity_Term_Reduction = null;
			if (event.data.pcard_Term && event.colDef.colId === 'pcard_Term') {
				event.data.extend_Term = null;
				event.data.working_capital_reduction = null;
				payload.working_capital_reduction = null;
			} else {
				event.data.pcard_Term = null;
				event.data.working_capital_reduction_pcard = null;
				payload.working_capital_reduction_pcard = null;
			}
		}

		if (event.colDef.colId === 'select' && event.data.select === 'NO') {
			event.data.extend_Term = null;
			event.data.pcard_Term = null;
			event.data.working_capital_reduction = null;
			event.data.working_capital_reduction_pcard = null;
			event.data.harmonization_Opportunity_Term = null;
			event.data.harmonization_Opportunity_Term_Reduction = null;
			payload.working_capital_reduction = null;
			payload.working_capital_reduction_pcard = null;
			payload.harmonization_Opportunity_Term = null;
			payload.harmonization_Opportunity_Term_Reduction = null;
		}

		await updateCapitalMarket(payload);
		this.props.parentGridRef.current.api.redrawRows();
		// gridApi.setSortModel([])
		// api.refreshCells ()
	};

	render() {
		const { data } = this.props;

		return (
			<>
				<div
					style={{ height: 'calc(100vh - 278px)' }}
					className="ag-theme-balham"
				>
					<AgGridReact
						{...this.gridOptions()}
						enableGroupEdit={true}
						ref={this.props.parentGridRef}
						modules={AllModules}
						autoGroupColumnDef={{
							headerName: 'Group',
							headerClass: 'header-ag-green',
						}}
						suppressDragLeaveHidesColumns={true}
						rowGroupPanelShow={'always'}
						groupDisplayType={'multipleColumns'}
						columnDefs={data.columnDefs}
						cacheBlockSize={200}
						defaultColDef={this.defaultColDefs}
						maxBlocksInCache={6}
						onCellValueChanged={this.handleCellValueChange}
						rowModelType="serverSide"
						maxConcurrentDatasourceRequests={1}
						multiSortKey="ctrl"
						onGridReady={this.onGridReady}
						enableRangeSelection={true}
						suppressCutToClipboard={true}
						suppressCellFocus={true}
						onFilterChanged={this.props.onFilterChanged}
					/>
				</div>
			</>
		);
	}
}

export default TableView;
